__webpack_require__.p = "/Daniel-s-Portfolio/";